import i18n from './index';

export function formatDate(date) {
  return new Date(date).toLocaleDateString(i18n.language, { dateStyle: 'short' });
}

export function formatDateTime(date) {
  return new Date(date).toLocaleString(i18n.language, {
    dateStyle: 'short',
    timeStyle: 'short',
  });
}

export function formatDateTimeLong(date) {
  return new Date(date).toLocaleString(i18n.language, {
    dateStyle: 'long',
    timeStyle: 'medium',
  });
}
